const C = {
  name: "Certificate",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.87822 0.887578C5.44064 0.312592 6.20902 0 7 0H13.4142L20 6.58579V13.126C21.7252 13.5701 23 15.1362 23 17C23 18.6273 22.0282 20.0277 20.6333 20.6524L22.8699 24H20.4599L18.9999 21.8L17.5299 24H15.1299L17.1343 21H7C6.2013 21 5.45049 20.6823 4.88751 20.1217C4.31257 19.5593 4 18.791 4 18V3C4 2.20133 4.31764 1.45055 4.87822 0.887578ZM15.5351 19C15.1948 18.4117 15 17.7286 15 17C15 15.1362 16.2748 13.5701 18 13.126V9H14C12.3477 9 11 7.65228 11 6V2H7C6.73318 2 6.48363 2.10567 6.30647 2.28762L6.29717 2.29717C6.10066 2.49368 6 2.74089 6 3V18C6 18.2668 6.10567 18.5164 6.28762 18.6935L6.29717 18.7028C6.49368 18.8993 6.74089 19 7 19H15.5351ZM19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15C17.8954 15 17 15.8954 17 17C17 18.1046 17.8954 19 19 19ZM13 6C13 6.54772 13.4523 7 14 7H17.5858L13 2.41421V6Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Certificate
};
